import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';

// @mui
import { styled } from '@mui/material/styles';
import { Typography, Box, Button, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import pageTitle from "../utils/pageTitles.json";
import { BlankCard } from '../components/cards/blankCard';
import { ConsoleUserListTable } from '../sections/console/consoleUserListTable';
import UsersListSvg from '../assets/svgs/usersList';
import { ToastContainer } from 'react-toastify';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { useNavigate } from 'react-router-dom';
import { checkButtonAccess } from 'src/utils/common';
import CustomModal from 'src/components/modal/customModal';
import Iconify from 'src/components/iconify';
import BulkUserImportForm from 'src/sections/console/bulkUserFrom';

// home main section container.
const MainSection = styled('div')(({ theme }) => ({
    padding: "64px 20px 0px 88px",
    backgroundColor: "rgb(240, 240, 240)"/* theme.palette.background.default */,
    height: '100vh',
    overflow: 'hidden'
}));

// Show home hading and filtes
const HeadingSection = styled('div')(() => ({
    width: '100%',
    padding: "20px 0px 20px 0px",
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row'
}));


const HeadingContentSection = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'row',
    gap: '15px',
    alignItems: 'center',
    justifyContent: 'center',
}));

const DetailsListSection = styled('div')(() => ({
    width: '100%',
    height: 'calc(100vh - 155px)',//'554px',
    overflow: 'hidden',
    overflowY: "scroll",
}));

const ConsoleUserList = () => (
    <Box sx={{ width: '100%' }}>
        <DetailsListSection className='reportListScroll'>
            <ConsoleUserListTable />
        </DetailsListSection>
    </Box>
)

const ConsoleUser = () => {

    const [openBulkModal, setOpenBulkModal] = useState(false);
    const navigate = useNavigate();
    const handleClick = () => {
        // if (!checkButtonAccess("addNewUser", "w")) return renderErrorMessage(ErrorMessage["invalidClick"])
        return navigate("/createUser", { state: { edit: false } })
    }
    return (
        <>
            <Helmet>
                <title> {`${pageTitle?.console}`} </title>
            </Helmet>

            <MainSection>

                {/* Heading and filters */}
                <HeadingSection>
                    <HeadingContentSection>
                        <Box sx={{
                            widht: '16px',
                            height: '16px',
                            mt: "-10px",
                        }}>
                            <UsersListSvg />
                        </Box>
                        <Typography variant='h5' sx={{ color: 'grey.10', fontWeight: 600 }}>
                            Console Users
                        </Typography>
                    </HeadingContentSection>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '10px',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                    {checkButtonAccess("createConsoleuser", "r") && <Button
                        startIcon={<PersonAddIcon />}
                        sx={{
                            backgroundColor: 'rgb(33, 43, 54)',
                            color: 'grey.100',
                            p: '0px 20px 0px 20px',
                            '&:hover': {
                                backgroundColor: 'rgb(69, 79, 91)'
                            }
                        }}
                        onClick={() => handleClick()}
                    >
                        Create User
                    </Button>}
                    {checkButtonAccess("bulkUser", "r") && 
                    <Button
                    startIcon={ <Iconify icon="fluent-mdl2:bulk-upload" /> }
                    sx={{
                        backgroundColor: 'rgb(33, 43, 54)',
                        color: 'grey.100',
                        p: '0px 20px 0px 20px',
                        '&:hover': {
                        backgroundColor: 'rgb(69, 79, 91)',
                        },
                    }}
                    onClick={() => setOpenBulkModal(true)}
                    >
                    Add Bulk Users 
                    </Button>}
                    </Box>
                </HeadingSection>

                <BlankCard
                    key="1"
                    sx={{
                        height: '100%',
                        width: '100%',
                        padding: '0px',
                        overflow: 'hidden',
                        // borderTopLeftRadius: '0px',
                        // borderTopRightRadius: '0px'
                    }}
                >
                    <ConsoleUserList sx={{ maxHeight: "100%", overflow: 'hidden' }} />
                </BlankCard>

            </MainSection>
            <CustomModal
            open={openBulkModal}
            title={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    Add Bulk Users
                    <Tooltip
                        arrow
                        placement="right"
                        title={
                            <ul style={{ paddingLeft: '1rem', margin: 0, fontSize: '0.78rem', lineHeight: 1.7 }}>
                                <li>Required headers: parentUserId, fullName, emailAddress, contactNumber, password, userName</li>
                                <li>Username &amp; email &amp; aliasedEmail must be unique for every row.</li>
                                <li>parentId should have permissions of l4</li>
                                <li>Products name should be in this format: SMS, Broadcast, Console, Lists, WaApi, DeepCall, Admin, ShortUrl</li>
                            </ul>
                        }
                    >
                        <InfoOutlinedIcon
                            sx={{
                                fontSize: '1rem',
                                color: 'text.secondary',
                                cursor: 'pointer',
                                '&:hover': { color: 'primary.main' },
                            }}
                        />
                    </Tooltip>
                </Box>
            }
            description={<BulkUserImportForm setBulkModalOpen={setOpenBulkModal} />}
            close={() => setOpenBulkModal(false)}
            isCloseIcon={true}
            />

        </>
    )
}


export default ConsoleUser;
